/**
 * paymentProviderPolicy — política única para el provider de pago.
 *
 * Decisión definitiva: **TODOS los países (incluida Argentina) pagan vía
 * Stripe**. MercadoPago quedó retirado del checkout: no hay ningún flujo de
 * pago nuevo que lo use y ya no existe un master switch para reactivarlo. Si en
 * el futuro se quisiera volver a MP, hay que reintroducir la rama AR de forma
 * deliberada (no es un flag), lo cual obliga a revisar todo el funnel.
 *
 * Lo que MercadoPago SÍ conserva y este archivo NO toca:
 *   - Webhooks `api/mercadopago/*` para suscriptores históricos: cancelaciones,
 *     renovaciones y sync de transacciones legacy.
 *   - La vista admin de transacciones MP (consulta histórica).
 *
 * Estas funciones se mantienen exportadas porque varios call sites las
 * consultan; hoy devuelven siempre Stripe, dejando muertas las ramas AR/MP que
 * puedan quedar en esos consumidores.
 */

export type PaymentProvider = "stripe" | "mercadopago";

/**
 * Provider a usar para el visitante. Stripe-only, sin excepción de país.
 */
export function getPaymentProviderForCountry(
  _country: string | null | undefined,
): PaymentProvider {
  return "stripe";
}

/** Atajo booleano. Siempre `false`: MercadoPago está retirado del checkout. */
export function shouldUseMercadoPago(_country: string | null | undefined): boolean {
  return false;
}
